<ng-container>
  <div class="log-metadata">
    <div class="v-center" style="gap: 8px;">
      <div class="log-metadata-time">{{log.eventCreated}}</div>
      <div class="log-metadata-category">
        <div class="badge verification-background">Verification</div>
        <ng-container *ngFor="let code of log.eventCodeList">
          <div class="badge xml-code">{{code}}</div>
        </ng-container>
      </div>
    </div>
    <div class="log-metadata-device"> 
      <div class="log-metadata-device-zone">{{log.zone_number}}</div>
      <div class="log-metadata-device-name" [class.no-name]="!log.name">{{log.name ?? 'No Name'}}</div>
    </div>
    <div class="log-metadata-other">{{log.email}} - {{log.status_text}}</div>
  </div>
  <div class="flex" *ngIf="!log.isLoading" [ngSwitch]="canIShowImage()" style="justify-content: end;">
    <div class="no-permission" *ngSwitchCase="'no permission'">No Permission</div>
    <div class="no-permission" *ngSwitchCase="'need to upgrade plan'">Upgrade your dealer plan to access archived video.</div>
    <div class="no-permission" *ngSwitchCase="'expired'">This video is expired</div>
    <div class="no-permission" *ngSwitchCase="'privacy mode'">This camera is in privacy mode</div>
    <div class="no-permission" *ngSwitchCase="'broken image'">Broken Image</div>
    <div class="no-permission" *ngSwitchCase="'broken video'">Broken Video</div>
    <ng-container *ngSwitchCase="'image'"><img [src]="log.imageUrl" (error)="isBrokenImage = true"/></ng-container>
    <div *ngSwitchDefault style="height: 168px;"><i class="material-icons" style="color: #4D96FF; font-size: 32px">verified_user</i></div>
  </div>
</ng-container>